import React from "react";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import "styled-components/macro";
import Dialog from "components/Dialog";
import { Order, Parcel } from "generated/graphql";
import { ParcelIcon, LocalisationPinIcon } from "icons";
import { Bagde } from "components/Card";
import { useDefaultRowParcel } from "domains/Task/types/Column";
import { SimpleTable } from "components/SimpleTable";
import { formatPhoneNumber } from "utils";
import useText from "constants/text";

export interface ShowOrderParcelProps {
  open: boolean;
  handleClose: () => void;
  order?: Order;
}
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
      height: 400,
    },
    top: {
      display: "flex",
    },
    caisse: {
      width: 40,
      height: 40,
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      opacity: 0.7,
      borderRadius: 12,
      marginRight: 12.5,
    },
    name: {
      fontSize: 12,
      fontWeight: 500,
      color: "#707070",
    },
    type: {
      fontSize: 21,
      fontWeight: 800,
      color: "#399ebf",
    },
    nameContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: 40,
      marginBottom: 5,
    },
    detail: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      justifyContent: "space-between",
    },
    time: {
      color: "#707070",
      fontSize: 14,
      marginLeft: 12.5,
    },
    number: {
      color: "#707070",
      fontSize: 14,
      marginLeft: 12.5,
    },
    bloc: {
      display: "flex",
      width: 200,
    },
    icon: {
      marginLeft: 2,
    },
  })
);
export function 
ShowOrderParcel({ open, handleClose, order }: ShowOrderParcelProps) {
  const styles = useStyles();
  const DefaultRowParcel = useDefaultRowParcel();
  const { text } = useText();
  const [parcels, setParcels] = React.useState<Array<Parcel>>([]);
  React.useEffect(() => {
    if (order) {
      setParcels(order?.order_parcels);
    }
  }, [order]);

  return (
    <Dialog
      title={text.all.order_parcels}
      open={open}
      handleClose={() => handleClose()}
      maxWidth="lg"
      key="add user dialog"
      cancelButtonTitle="EXIT"
    >
      <Grid container className={styles.root}>
        <Grid item xs={6}>
          <div className={styles.top}>
            <div className={styles.caisse}>
              <div
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                <ParcelIcon />
              </div>
            </div>
            <div className={styles.nameContent}>
              <div
                className={styles.name}
              >{`${order?.order_receiver?.receiver_firstname} ${order?.order_receiver?.receiver_lastname}`}</div>
              <div className={styles.name}>
                {formatPhoneNumber(order?.order_receiver?.receiver_phone_number)}
              </div>
            </div>
            <div className={styles.detail}>
              <div className={styles.bloc}>
                <div className={styles.icon}>
                  <Bagde
                    variante="contained"
                    value={<LocalisationPinIcon />}
                    height={20}
                    width={20}
                    fontSize={10}
                    parcel
                    background="#e3f8fa"
                  />
                </div>
                <div className={styles.number}>
                  {order?.order_receiver?.receiver_address?.address}
                </div>
              </div>
              <div className={styles.bloc}>
                <div className={styles.icon}>
                  <Bagde
                    variante="contained"
                    value={parcels?.length?.toString() ?? "0"}
                    height={20}
                    width={20}
                    fontSize={10}
                    parcel
                    background="#e3f8fa"
                  />
                </div>
                <div className={styles.time}>{text.all.parcels}</div>
              </div>
            </div>
        </div>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            marginTop: -140,
          }}
        >
          <SimpleTable rowsIdentifier="_id" columns={DefaultRowParcel} data={parcels} />
        </Grid>
      </Grid>
    </Dialog>
  );
}
